import { NO_PRINTER_ID, BM_PRINTER_ID } from '@/constants';
export var printers = [
    {
        id: NO_PRINTER_ID, // there is no such ID in the material
        name: 'No printer',
    },
    {
        id: 1,
        name: 'LASERDRUCKER',
    },
    {
        id: 2,
        name: 'CMS-P1-PLOTTER',
    },
    {
        id: 3,
        name: 'THERMOMARK-S1-S1.1_THERMO-S1',
    },
    {
        id: 4,
        name: 'THERMOMARK X1',
    },
    {
        id: 5,
        name: 'BLUEMARK, ID, Color, CLED',
    },
    {
        id: 6,
        name: 'THERMOMARK W1',
    },
    {
        id: 7,
        name: 'P1 ENGRAVING UNIT',
    },
    {
        id: 8,
        name: 'TTP 4320',
    },
    {
        id: 9,
        name: 'MATRIXDRUCKER',
    },
    {
        id: 10,
        name: 'WIREMARK',
    },
    {
        id: 11,
        name: 'CUTFOX-10',
    },
    {
        id: 12,
        name: 'PRINTJET',
    },
    {
        id: 13,
        name: 'THERMOMARK W2',
    },
    {
        id: 14,
        name: 'THERMOMARK X1.2',
    },
    {
        id: 15,
        name: 'THERMOMARK S1.1',
    },
    {
        id: 16,
        name: 'THERMOMARK Card, Thermomark Card 2.0, Thermomark Prime, Thermomark Prime 2.0',
    },
    {
        id: 17,
        name: 'THERMOMARK Roll, Thermomark Roll2.0, Thermomark Rollmaster(300/600/300L), Thermomark Roll X1',
    },
    {
        id: 18,
        name: 'TOPMARK',
    },
    {
        id: 19,
        name: 'THERMOFOX/Thermomark Go/Thermomark Go K',
    },
    {
        id: 20,
        name: 'THERMOMARK E300 / E600 (D)',
    },
    {
        id: 21,
        name: 'THERMOMARK E300 DOUBLE',
    },
    {
        id: 22,
        name: 'BLUEMARK E.Card',
    },
    {
        id: 23,
        name: 'PRIME2.0',
    },
];
export var getPrinterName = function (id) {
    var printer = printers.find(function (p) { return p.id === id; });
    return printer === null || printer === void 0 ? void 0 : printer.name;
};
export var isColorOptionAvailable = function (printerId) {
    return [NO_PRINTER_ID, BM_PRINTER_ID].includes(printerId);
};
export var isColorPrinterAvailable = function (printerList) {
    return printerList.includes(BM_PRINTER_ID);
};
